import React from "react";
import { systemThemes } from "../themes/systemThemes";
import { Link } from "react-router-dom";

export default function ThemeList() {
  return (
    <div style={{ padding: "30px" }}>
      <h1>Available Themes</h1>

      <div style={{ display: "flex", gap: "30px", flexWrap: "wrap" }}>
        {systemThemes.map((theme) => (
          <div
            key={theme.id}
            style={{
              width: "280px",
              padding: "20px",
              border: "1px solid #ddd",
              borderRadius: "10px",
              background: "#fff",
            }}
          >
            <h3>{theme.name}</h3>
            <div
              style={{
                height: "150px",
                background: theme.previewThumbnail,
                borderRadius: "10px",
                marginBottom: "15px",
              }}
            />
            <Link to={`/theme/${theme.id}`}>
              <button
                style={{
                  padding: "10px 15px",
                  background: "#6C63FF",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                }}
              >
                Preview Theme
              </button>
            </Link>
          </div>
        ))}
      </div>
    </div>
  );
}
